import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter} from "../../../utils/formatters";

class MoneyTransferDocumentList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const columns = this.props.columns || {
            "moneyrepository.name": {header: this.props.moneyrepositoryType === 'BankAccount' ? 'Bankszámla' : 'Pénztár', width: 2, sortable, filterable},
            "partnername": {header: 'Partner', width: 2, sortable, filterable},
            "transferdate": {header: 'Időpont', width: 2, sortable, filterable},
            "total": {header: 'Összeg', width: 2, sortable, filterable, renderer: CurrencyFormatter},
            ...(this.props.moneyrepositoryType === 'CashRepository' ? {
                "cashier.name": {header: 'Pénztáros', width: 2, sortable, filterable},
                "number": {header: 'Bizonylatszám', width: 2, sortable, filterable},
                "comment.text": {header: 'Megjegyzés', width: 2, sortable, filterable},
            } : {}),
        };
        let {view, componentConfig, filter, selection, isLoading, columnSort} = this.props;
        if (!filter) {
            filter = [];
        }
        if (this.props.moneyrepositoryType) {
            filter.push({field: "moneyrepository.component_type", value: this.props.moneyrepositoryType});
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "MoneyTransferDocumentList"}
                {...props}
                columnSort={columnSort}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                aggregations={{
                    fields: {
                        "total": {
                            field: "total", type: "SUM"
                        }
                    }
                }}
                columns={columns}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default MoneyTransferDocumentList;
